module.exports = __webpack_public_path__ + "img/大数据买一赠二.1b50ec7b.png";